// CopiesInput.jsx – Anzahl Exemplare: Schieberegler bis 30, grössere Zahlen direkt eintippen
import React, { useEffect, useState } from 'react';

// Bis 30 mit dem Regler, darüber nur über das Zahlenfeld (höchstens 999).
export const SLIDER_MAX = 30;
export const COPIES_MAX = 999;

// value = aktuelle Anzahl, onChange = wird mit der neuen Anzahl aufgerufen.
// text = was im Zahlenfeld steht (darf beim Tippen kurz leer sein).
export function CopiesInput({ value, onChange }) {
  const [text, setText] = useState(String(value));
  // Ändert sich die Anzahl von aussen (z.B. Regler), das Zahlenfeld nachführen.
  useEffect(() => { setText(String(value)); }, [value]);

  // Beim Verlassen des Feldes oder mit Enter: ungültige Eingaben verwerfen, sonst übernehmen.
  const commit = (raw) => {
    const n = Math.round(Number(raw));
    if (!Number.isFinite(n) || n < 1) { setText(String(value)); return; }
    onChange(Math.min(COPIES_MAX, n));
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        {/* Steht die Anzahl über 30, bleibt der Regler am rechten Ende. */}
        <input
          type="range" min={1} max={SLIDER_MAX} value={Math.min(value, SLIDER_MAX)}
          onChange={e => onChange(Number(e.target.value))}
          style={{ flex: 1 }} aria-label="Anzahl Exemplare"
        />
        <input
          type="number" inputMode="numeric" min={1} max={COPIES_MAX} value={text}
          onChange={e => {
            setText(e.target.value);
            const n = Math.round(Number(e.target.value));
            if (e.target.value !== '' && Number.isFinite(n) && n >= 1) onChange(Math.min(COPIES_MAX, n));
          }}
          onBlur={e => commit(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); commit(e.currentTarget.value); } }}
          aria-label="Anzahl Exemplare eingeben"
          style={{
            width: 72, fontWeight: 700, fontSize: 20, textAlign: 'center', color: '#1540dc',
            border: '1.5px solid #c9d3f5', borderRadius: 8, padding: '4px 6px', background: '#fff',
          }}
        />
      </div>
      <div style={{ fontSize: 12, color: '#999', marginTop: 6 }}>
        Mehr als {SLIDER_MAX} Exemplare? Zahl direkt ins Feld eingeben.
      </div>
    </div>
  );
}
